import { ChangeEvent, useEffect } from 'react';
import { TextField } from '@mui/material';
import { ParameterProps } from './parameterSelector';
import { ParameterValidatorService } from './parameterValidatorService';
import { useTranslation } from 'react-i18next';
import i18n from '../../../../locales/i18n';

type Props = ParameterProps & {
  range: number[];
};

const DoubleParameter = ({ type, parameter, name_de, name_en, selected, onChange, range }: Props): JSX.Element => {
  const { t } = useTranslation();
  const currentLanguage = i18n.language;

  let printValue: number | string = (selected ?? range[0] ?? 0) as number;
  if (isNaN(printValue)) {
    printValue = '';
  }
  useEffect(() => {
    if (printValue !== selected) {
      onChange(printValue);
    }
  });

  const error = ParameterValidatorService.validateNumber({ type, parameter, range }, selected);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => onChange(Number(e.target.value));
  return (
    <TextField
      error={error !== undefined}
      label={`${currentLanguage === 'de' ? name_de : name_en} ${t('real out of')} [${range[0] ?? '-inf'}, ${range[1] ?? 'inf'}]`}
      type={'number'}
      variant={'filled'}
      InputLabelProps={{
        shrink: true,
      }}
      fullWidth
      value={printValue}
      onChange={handleChange}
      helperText={error ? t(error) : undefined}
    />
  );
};

export default DoubleParameter;
